import customerResource from "../resources/customerResource";
import {businessTypes} from "codelist/";
import Customer from "../domain/customer";

export default {
  newCustomer() {
    return new Customer({address: {}});
  },
  async findAll () {
    const response = await customerResource.query();
    if (response.ok) {
      return response.data.map((customerData) => new Customer(customerData));
    } else {
      return null;
    }
  },
  async create (customer) {
    const response = await customerResource.save({}, customer);
    if (response.ok) {
      return new Customer(response.data);
    } else {
      return null;
    }
  },
  async update (customer) {
    const response = await customerResource.update({}, customer);
    if (response.ok) {
      return new Customer(response.data);
    } else {
      return null;
    }
  },
  async delete(id) {
    return customerResource.delete({id: id});
  },
  async activate (id) {
    return customerResource.activate({id: id}, {});
  },
  async deactivate (id) {
    return customerResource.deactivate({id: id}, {});
  }
}



// WEBPACK FOOTER //
// ./client/services/customerService.js